import { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTheme } from "@mui/material/styles";
import { Box, Grid, IconButton, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from "../../assets/landing_page/Images/close.png";
import http from "../../utils/http-common";
import Topbar from "../Drawer/Topbar";
import Sidebar from "../Drawer/Sidebar";
import FeedbackForm from "../../pages/FeedbackForm";
import { setTemplateForCreate } from "../../Slices/planslice";
const MainLayout = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [accessData, setAccessData] = useState([]);
  const [isMyPlanBoxVisible, setIsMyPlanBoxVisible] = useState(true);
  const [isSharePlanBoxVisible, setIsSharePlanBoxVisible] = useState(true);
  const [isUserBoxVisible, setIsUserBoxVisible] = useState(true);
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down("lg"));
  const location = useLocation();
  const dispatch = useDispatch();

  const isMyPlanPage = location.pathname === "/home/myplans";
  const isUserPage = location.pathname === "/home/users";
  const isSharePlanMainPage = location.pathname === "/home/shareplan";
  const isSharePlanPage = location.pathname === "/home/plan-share-screen";

  const isAnalysis = location.pathname === "/home/analysis";
  const isAnalysisReport = location.pathname === "/home/AnalysisReport";
  const isTemplatePage = location.pathname === "/home/templates";
  const isViewTemplatePage = location.pathname === "/home/viewtemplate";
  const isReportPage = location.pathname === "/home/reports";
  const isHealthReportPage = location.pathname === "/home/healthreport";
  const isViewPlanPage = location.pathname === "/home/viewplan";

  useEffect(() => {
    getHomePageData();
    getAllUserPageData();
    getNoAccessPageData();
    getMyPlanPageData();
  }, []);
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/home/createplan");
    dispatch(setTemplateForCreate({
      isTemplate: true,
      table: false,
    }));
  };
  const [homePageData, setHomePageData] = useState([]);
  const getHomePageData = async () => {
    const payload = {
      metadata_type: "PlanShare Home Page"
    };
    try {
      const response = await http.post(
        "/master_service/template/category_list", payload
      );
      if (response.status === 200) {
        setHomePageData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const [myPlanPageData, setMyPlanPageData] = useState([]);
  const getMyPlanPageData = async () => {
    const payload = {
      metadata_type: "My Plans Page"
    };
    try {
      const response = await http.post(
        "/master_service/template/category_list", payload
      );
      if (response.status === 200) {
        setMyPlanPageData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  const [sharePlanPageData, setSharePlanPageData] = useState([]);
  const getSharePlanPageData = async () => {
    const payload = {
      metadata_type: "Share Plan Page"
    };
    try {
      const response = await http.post(
        "/master_service/template/category_list", payload
      );
      if (response.status === 200) {
        setSharePlanPageData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const [allAccessPageData, setAllAccessPageData] = useState([]);
  const getAllAccessPageData = async () => {
    const payload = {
      metadata_type: "Share Plan – All Access"
    };
    try {
      const response = await http.post(
        "/master_service/template/category_list", payload
      );
      if (response.status === 200) {
        setAllAccessPageData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const [noAccessPageData, setNoAccessPageData] = useState([]);
  const getNoAccessPageData = async () => {
    const payload = {
      metadata_type: "Share Plan – No Access"
    };
    try {
      const response = await http.post(
        "/master_service/template/category_list", payload
      );
      if (response.status === 200) {
        setNoAccessPageData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  const [limitedAccessLogPageData, setLimitedAccessLogPageData] = useState([]);
  const getLimitedAccessLogPageData = async () => {
    const payload = {
      metadata_type: "Share Plan – Limited Access Log"
    };
    try {
      const response = await http.post(
        "/master_service/template/category_list", payload
      );
      if (response.status === 200) {
        setLimitedAccessLogPageData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  const [limitedAccessPageData, setLimitedAccessPageData] = useState([]);
  const getLimitedAccessPageData = async () => {
    const payload = {
      metadata_type: "Share Plan – Limited Access"
    };
    try {
      const response = await http.post(
        "/master_service/template/category_list", payload
      );
      if (response.status === 200) {
        setLimitedAccessPageData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  const [allUserPageData, setAllUserPageData] = useState([]);
  const getAllUserPageData = async () => {
    const payload = {
      metadata_type: "All Users Page"
    };
    try {
      const response = await http.post(
        "/master_service/template/category_list", payload
      );
      if (response.status === 200) {
        setAllUserPageData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  // Handle responsive sidebar collapse
  useEffect(() => {
    if (matchDownLG) {
      setDrawerOpen(false);
    }
  }, [matchDownLG]);

  // Toggle the sidebar
  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        overflow: "hidden", // Ensure no content spills out
      }}
    >
      {/* Topbar */}
      {/* <Topbar drawerOpen={drawerOpen} /> */}

      {/* Main Layout */}
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          height: "calc(100% - 97px)", // Adjust for Topbar height
          overflow: "hidden", // Prevent overflow
        }}
      >
        {/* Sidebar */}
        <Box
          sx={{
            width: drawerOpen ? 190 : 45, // Adjust sidebar width dynamically
            flexShrink: 0,
            transition: "width 0.3s ease", // Smooth transition
            overflow: "hidden", // Prevent overflow in the sidebar
          }}
        >
          <Sidebar
            toggleDrawer={toggleDrawer}
            drawerOpen={drawerOpen}
            setDrawerOpen={setDrawerOpen}
          />
        </Box>

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: "100%",
            //backgroundColor: isTemplatePage || isViewTemplatePage || isReportPage || isHealthReportPage || isAnalysis || isAnalysisReport ? "#FFF" : "#FAFAFA",
            backgroundColor: "#FFF",
            display: "flex",
            mt: '4px',
            flexDirection: "column",
           overflow: isViewPlanPage || isViewTemplatePage ? "hidden" : "auto",
          }}
        >
          {isUserPage && isUserBoxVisible && <Box sx={{
            backgroundColor: "#E5EEFB66", // Semi-transparent pink
            minWidth: "85vw",
            fontFamily: "Inter, sans-serif",
            fontWeight: 700,
            fontSize: "10px",
            color: "black", // Ensure text remains unaffected
            textAlign: "left",
            transition: "width 0.3s ease",
          }}>
            <Grid item xs={12} sx={{
              marginTop: "10px", paddingLeft: "10px", marginBottom: "10px", display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
              <Grid item xs={11}>
                {allUserPageData[0]?.metadata_name && (() => {
                  const text = allUserPageData[0].metadata_name;
                  const proTipText = "Pro Tip:";
                  const highlightedText = "Invite your team";
                  const proTipIndex = text.indexOf(proTipText);
                  const inviteIndex = text.indexOf(highlightedText);

                  return (
                    <Typography sx={{ fontSize: "12px" }}>
                      {/* Pro Tip with Bold Font */}
                      {proTipIndex !== -1 && (
                        <span style={{ fontWeight: "bold" }}>{proTipText}</span>
                      )}

                      {/* Remaining Text Before "Invite your team" */}
                      {text.substring(proTipText.length, inviteIndex)}

                      {/* Invite your team - Styled as Clickable & Underlined */}
                      <span
                        style={{
                          color: "#FF2800",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() => (window.location.href = "/home/adduser")}
                      >
                        {highlightedText}
                      </span>

                      {/* Remaining Text After "Invite your team" */}
                      {text.substring(inviteIndex + highlightedText.length)}
                    </Typography>
                  );
                })()}
              </Grid>

              {/* Right side: Close Button */}
              <Grid item xs={1} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <IconButton onClick={() => setIsUserBoxVisible(false)} size="small">
                  <img
                    src={CloseIcon}
                    alt="close"
                    style={{ width: "20px", height: "20px" }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </Box>}
          {isMyPlanPage && isMyPlanBoxVisible && <Box sx={{
            backgroundColor: "#E5EEFB66", // Semi-transparent pink
            minWidth: "85vw",
            fontFamily: "Inter, sans-serif",
            fontWeight: 700,
            fontSize: "10px",
            color: "black", // Ensure text remains unaffected
            textAlign: "left",
            transition: "width 0.3s ease",
          }}>
            <Grid item xs={12} sx={{
              marginTop: "10px", paddingLeft: "10px", marginBottom: "10px",
              display: "flex",
              alignItems: "center"
            }}>
              {myPlanPageData[0]?.metadata_name && (() => {
                let text = myPlanPageData[0].metadata_name.trim();
                const proTipText = "Pro Tip:";

                if (text.startsWith(proTipText)) {
                  text = text.replace(proTipText, "").trim();
                }

                // Clickable Links Mapping
                const clickableLinks = [
                  { text: "Share plans", route: "/home/shareplan" },
                  { text: "New plan", route: "/home/createplan" },
                  { text: "Exploring templates", route: "/home/templates" },
                ];

                // Replace text occurrences with clickable links
                clickableLinks.forEach(({ text: linkText, route }) => {
                  text = text.replace(
                    linkText,
                    `<a href="${route}" style="color: #FF2800; cursor: pointer; text-decoration: underline;">${linkText}</a>`
                  );
                });

                return (
                  <Typography sx={{ fontSize: "12px", flexGrow: 1 }}>
                    <span style={{ fontWeight: "bold" }}>{proTipText} </span>
                    <span dangerouslySetInnerHTML={{ __html: text }} />
                  </Typography>
                );
              })()}

              {/* Close Icon */}
              <IconButton onClick={() => setIsMyPlanBoxVisible(false)} size="small">
                <img src={CloseIcon} alt="close" style={{ width: "20px", height: "20px" }} />
              </IconButton>
            </Grid>
          </Box>}
          {(isSharePlanPage || isSharePlanMainPage) && isSharePlanBoxVisible && <Box sx={{
            backgroundColor: "#E5EEFB66", // Semi-transparent pink
            minWidth: "85vw",
            fontFamily: "Inter, sans-serif",
            fontWeight: 700,
            fontSize: "14px",
            textAlign: "left",
            transition: "width 0.3s ease"
          }}>
            <Grid item xs={12} sx={{
              marginTop: "10px", paddingLeft: "10px", marginBottom: "10px", display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
              <Grid item xs={11}>
                {noAccessPageData[0]?.metadata_name && (() => {
                  const text = noAccessPageData[0].metadata_name;
                  const proTipText = "Pro Tip:";

                  return (
                    <Typography sx={{ fontSize: "12px" }}>
                      <span style={{ fontWeight: "bold" }}>{proTipText}</span>
                      {text.substring(proTipText.length)}
                    </Typography>
                  );
                })()}
              </Grid>

              {/* Right side: Close Button */}
              <Grid item xs={1} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <IconButton onClick={() => setIsSharePlanBoxVisible(false)} size="small">
                  <img
                    src={CloseIcon}
                    alt="close"
                    style={{ width: "20px", height: "20px" }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </Box>}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              overflow: isViewPlanPage ||isViewTemplatePage ? "hidden" : "auto", // Handle scrolling
              padding: isViewPlanPage || isViewTemplatePage ? "" : { xs: 1, sm: 1 },
              flexGrow: 1, // Ensure the content area grows to fill the space
            }}
          >
            <Outlet context={{ drawerOpen: drawerOpen, toggleDrawer: toggleDrawer }} />
          </Box>
        </Box>
      </Box>

      {/* Feedback Component */}
      <FeedbackForm />
    </Box>
  );
};

export default MainLayout;
